import { includedPropList, includedT2PropList } from "../../../pages/activityBuilder/modules/organicSoil/organicSoil";
import type { ModuleFull, OrganicSoilResponse } from "../../../pages/activityBuilder/modules/organicSoil/organicSoilTypes"
import { FEModules } from "../../../utils/moduleList";
import { FEModulesObj } from "../../../utils/moduleList";
import { apiSlice, publicApiSlice, TagTypes } from "../../apiSlice";
import { createModuleGetApi, createModuleUpdateApi } from "./factories/createModuleApi";
import { transformModuleResponse, prepareModulePayload } from "./factories/moduleApiUtils";

// Define constants for the module
const MODULE_TYPE = "OrganicSoil";
const TAG: TagTypes = "OrganicSoil";
const TAG_DEFAULTS: TagTypes = "OrganicSoilDefaults";
const ENDPOINT = FEModulesObj[FEModules.OrganicSoil].path;

const t1PercentageProps = ["ditches_area", "soil_fire_impact_percentage", "peat_ditches_area"];

const transformResponse = (response: OrganicSoilResponse) => transformModuleResponse<OrganicSoilResponse, ModuleFull>({
	response,
	includedPropList,
	includedT2PropList,
	percentageProps: t1PercentageProps
})

const organicSoilApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const publicOrganicSoilApiSlice = createModuleGetApi<ModuleFull>({
	apiSlice: publicApiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformResponse,
})

const transformUpdatePayload = (data: ModuleFull, activityId: number) => prepareModulePayload({
	moduleData: data.module,
	tiertwoData: data.tiertwo,
	percentageProps: t1PercentageProps,
	activityId
})

const mutationApiSlice = createModuleUpdateApi<ModuleFull, OrganicSoilResponse>({
	apiSlice,
	path: ENDPOINT,
	moduleName: MODULE_TYPE,
	tag: TAG,
	tagDefaults: TAG_DEFAULTS,
	transformUpdatePayload,
})

export const {
	useGetOrganicSoilQuery,
	useGetOrganicSoilDefaultsQuery
} = organicSoilApiSlice;

export const {
	useGetOrganicSoilQuery: usePublicGetOrganicSoilQuery,
	useGetOrganicSoilDefaultsQuery: usePublicGetOrganicSoilDefaultsQuery
} = publicOrganicSoilApiSlice;

export const {
	useUpdateOrganicSoilMutation,
} = mutationApiSlice;
